import notify from "devextreme/ui/notify";
import { call, Next, Result, select, takeEvery, updateStore } from "starfx";

import { IAppNotify, ThunkCtx } from "@app/types";

import { schema } from "../schema";
import { xThunk } from "../xapis";

import type { TDialogs } from "../schema/notify.def";
type TMessageText = { message: string };

const db = schema;
let i = 0;
export const xt1 = xThunk.create<TMessageText>(
  "xt1",
  { supervisor: takeEvery },
  function* (ctx, next) {
    const message = yield* select(db.notify.select);
    console.log("message", message);
    // yield* schema.update(
    //   db.notify.update({ key: 'message', value: ctx.payload.message }),
    // );
    yield* updateStore(
      db.notify.update({
        key: "message",
        value: `${ctx.payload.message}${i++}`,
      })
    );
    yield* next();
  }
);

export const sfxNotify = xThunk.create<IAppNotify>(
  "/sfx/appNotify",
  { supervisor: takeEvery },
  function* (ctx, next) {
    const { message, type, duration, position, animation } = ctx.payload;
    if (!message) return;
    const thePosition = position || "top";
    const direction = thePosition === "top" ? "down-push" : "up-push";
    const thePosition2 = thePosition === "top" ? "top center" : "bottom center";
    yield* updateStore(
      db.notify.update({
        key: "message",
        value: `${ctx.payload.message} (${i++})`,
      })
    );
    yield* call(() =>
      notify(
        {
          message,
          width: 400,
          animation: animation || {
            show: {
              type: "fade",
              duration: 400,
              from: 0,
              to: 1,
            },
            hide: { type: "fade", duration: 40, to: 0 },
          },
          type,
          duration,
        },
        { position: thePosition2, direction }
      )
    );
    yield* next();
  }
);

/* 
position: {
            at: position || 'top',
            my: position || 'top',
            of: '#root',
            offset: (position || 'top') === 'top' ? '0 22' : '0 -22',
            
          },
        }, direction}

*/

export const setDialogResult = xThunk.create<Partial<TDialogs>>(
  "/sfx/setDialogResult",
  { supervisor: takeEvery },
  function* (ctx, next) {
    yield* updateStore(
      db.dialogs.update({ key: "result", value: ctx.payload.result })
    );
    yield* next();
  }
);
